import axios from 'axios';
import { put, call, takeLeading, delay } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes';
import { api_urls } from '../../utils/api-urls';
import Swal from "sweetalert2";
import { change_ecommerce_category_status, change_ecommerce_product_status, change_ecommerce_sub_category_status, create_ecommerce_attribute, create_ecommerce_category, create_ecommerce_product, create_ecommerce_sub_category, delete_ecommerce_attribute, delete_ecommerce_category, delete_ecommerce_product, delete_ecommerce_sub_category, get_ecommerce_attribute, get_ecommerce_category, get_ecommerce_product, get_ecommerce_sub_category, get_ecommerce_sub_category_by_category_id, update_ecommerce_attribute, update_ecommerce_category, update_ecommerce_product, update_ecommerce_sub_category } from '../../utils/api-routes';

function* getEcommerceCategory() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_ecommerce_category}`);
        // console.log("Get Ecommerce Category Saga Response ::: ", data)

        if (data?.status) {
            yield delay(500);
            yield put({ type: actionTypes.SET_ECOMMERCE_CATEGORY, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Ecommerce Category Saga Error ::: ", error)
    }
}

function* createEcommerceCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + create_ecommerce_category}`, payload?.data);
        console.log("Create Ecommerce Category Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: "Ecommerce Category Created Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: 'Failed To Create Ecommerce Category',
            text: "Failed To Create Ecommerce Category",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Create Ecommerce Category Saga Error ::: ", error?.response?.data)
    }
}

function* updateEcommerceCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_ecommerce_category}`, payload?.data);
        console.log("Update Ecommerce Category Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: "Ecommerce Category Updated Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_ECOMMERCE_CATEGORY, payload: null })
        }

    } catch (error) {
        console.log("Update Ecommerce Category Saga Error ::: ", error?.response?.data)
    }
}

function* deleteEcommerceCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Delete`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        })

        console.log("Result ::: ", result)

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + delete_ecommerce_category}`, payload);
            console.log("Delete Ecommerce Category Saga Response ::: ", data)
            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    title: "Ecommerce Category Deleted Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_ECOMMERCE_CATEGORY, payload: null })

            }
        }
    } catch (error) {
        Swal.fire({
            icon: "error",

            text: "Failed To Delete Ecommerce Category",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Delete Ecommerce Category Saga Error ::: ", error?.response?.data)
    }
}

function* changeEcommerceCategoryStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Change Status`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        })

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + change_ecommerce_category_status}`, payload);
            console.log("Change Status Ecommerce Category Saga Response ::: ", data)

            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    title: "Status Change Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_ECOMMERCE_CATEGORY, payload: null })
            }
        }

    } catch (error) {
        Swal.fire({
            icon: "error",

            text: "Failed To Change Status",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Change Status Ecommerce Category Saga Error ::: ", error?.response?.data)
    }
}

function* getEcommerceSubCategoryByCategoryId(action) {
    const { payload } = action;
    console.log("Payload ::: ", payload)

    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.post, `${api_urls + get_ecommerce_sub_category_by_category_id}`, payload);
        console.log("Get Ecommerce Sub Category By Category ID Saga Response ::: ", data)

        if (data?.status) {
            yield delay(500);
            yield put({ type: actionTypes.SET_ECOMMERCE_SUB_CATEGORY_BY_CATEGORY_ID, payload: data?.results ? data?.results : [] });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });

    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Ecommerce Sub Category By Category ID Saga Error ::: ", error?.response?.data)
    }
}

function* getEcommerceSubCategory() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_ecommerce_sub_category}`);
        console.log("Get Ecommerce Sub Category Saga Response ::: ", data)

        if (data?.status) {
            yield delay(500);
            yield put({ type: actionTypes.SET_ECOMMERCE_SUB_CATEGORY, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Ecommerce Sub Category Saga Error ::: ", error)
    }
}

function* createEcommerceSubCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + create_ecommerce_sub_category}`, payload?.data);
        console.log("Create Ecommerce Sub Category Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: "Ecommerce Sub Category Created Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: 'Failed To Create Ecommerce Sub Category',
            text: "Failed To Create Ecommerce Sub Category",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Create Ecommerce Sub Category Saga Error ::: ", error?.response?.data)
    }
}

function* updateEcommerceSubCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_ecommerce_sub_category}`, payload?.data);
        console.log("Update Ecommerce Sub Category Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: "Ecommerce Sub Category Updated Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_ECOMMERCE_SUB_CATEGORY, payload: null })
        }

    } catch (error) {
        console.log("Update Ecommerce Sub Category Saga Error ::: ", error?.response?.data)
    }
}

function* deleteEcommerceSubCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Delete`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        })

        console.log("Result ::: ", result)

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + delete_ecommerce_sub_category}`, payload);
            console.log("Delete Ecommerce Sub Category Saga Response ::: ", data)
            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    title: "Ecommerce SubCategory Deleted Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_ECOMMERCE_SUB_CATEGORY, payload: null })
                if (payload?.productCategoryId) {
                    yield put({ type: actionTypes.GET_ECOMMERCE_SUB_CATEGORY_BY_CATEGORY_ID, payload: { productCategoryId: payload?.productCategoryId } })
                }
            }
        }
    } catch (error) {
        Swal.fire({
            icon: "error",

            text: "Failed To Delete Ecommerce SubCategory",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Delete Ecommerce Sub Category Saga Error ::: ", error?.response?.data)
    }
}

function* changeEcommerceSubCategoryStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Change Status`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        })

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + change_ecommerce_sub_category_status}`, payload);
            console.log("Change Status Ecommerce Sub Category Saga Response ::: ", data)

            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    title: "Status Change Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_ECOMMERCE_SUB_CATEGORY, payload: null })
                if (payload?.productCategoryId) {
                    yield put({ type: actionTypes.GET_ECOMMERCE_SUB_CATEGORY_BY_CATEGORY_ID, payload: { productCategoryId: payload?.productCategoryId } })
                }
            }
        }

    } catch (error) {
        Swal.fire({
            icon: "error",

            text: "Failed To Change Status",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Change Status Ecommerce Sub Category Saga Error ::: ", error?.response?.data)
    }
}

function* getEcommerceAttribute() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_ecommerce_attribute}`);
        // console.log("Get Ecommerce Attribute Saga Response ::: ", data)

        if (data?.status) {
            yield delay(500);
            yield put({ type: actionTypes.SET_ECOMMERCE_ATTRIBUTE, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Ecommerce Attribute Saga Error ::: ", error)
    }
}

function* createEcommerceAttribute(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + create_ecommerce_attribute}`, payload?.data);
        console.log("Create Ecommerce Attribute Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: "Ecommerce Attribute Created Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            title: 'Failed To Create Ecommerce Attribute',
            text: "Failed To Create Ecommerce Attribute",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Create Ecommerce Attribute Saga Error ::: ", error?.response?.data)
    }
}

function* updateEcommerceAttribute(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_ecommerce_attribute}`, payload?.data);
        console.log("Update Ecommerce Attribute Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                title: "Ecommerce Attribute Updated Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_ECOMMERCE_ATTRIBUTE, payload: null })
        }

    } catch (error) {
        console.log("Update Ecommerce Attribute Saga Error ::: ", error?.response?.data)
    }
}

function* deleteEcommerceAttribute(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Delete`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        })

        console.log("Result ::: ", result)

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + delete_ecommerce_attribute}`, payload);
            console.log("Delete Ecommerce Attribute Saga Response ::: ", data)
            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    title: "Ecommerce Attribute Deleted Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_ECOMMERCE_ATTRIBUTE, payload: null })

            }
        }
    } catch (error) {
        Swal.fire({
            icon: "error",

            text: "Failed To Delete Ecommerce Attribute",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Delete Ecommerce Attribute Saga Error ::: ", error?.response?.data)
    }
}

//! Product
function* getEcommerceProduct() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_ecommerce_product}`);
        console.log("Get Ecommerce Product Saga Response ::: ", data)

        if (data?.status) {
            yield delay(500);
            yield put({ type: actionTypes.SET_ECOMMERCE_PRODUCT, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Ecommerce Product Saga Error ::: ", error)
    }
}

function* createEcommerceProduct(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + create_ecommerce_product}`, payload?.data);
        console.log("Create Ecommerce Product Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({ icon: "success", title: "Ecommerce Product Created Successfully", showConfirmButton: false, timer: 2000, });
            yield call(payload?.onComplete)
        }
    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed To Create Ecommerce Product', text: "Failed To Create Ecommerce Product", showConfirmButton: false, timer: 2000, });
        console.log("Create Ecommerce Product Saga Error ::: ", error?.response?.data)
    }
}

function* updateEcommerceProduct(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_ecommerce_product}`, payload?.data);
        console.log("Update Ecommerce Product Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({ icon: "success", title: "Ecommerce Product Updated Successfully", showConfirmButton: false, timer: 2000, });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_ECOMMERCE_PRODUCT, payload: null })
        }
    } catch (error) {
        Swal.fire({ icon: "error", title: 'Failed To Update Ecommerce Product', text: "Failed To Update Ecommerce Product", showConfirmButton: false, timer: 2000, });
        console.log("Update Ecommerce Product Saga Error ::: ", error?.response?.data)
    }
}

function* deleteEcommerceProduct(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)
        const result = yield Swal.fire({ title: `Are You Sure To Delete`, text: "You won't be able to revert this!", icon: "warning", showCancelButton: true, confirmButtonColor: "#2A9BAA", cancelButtonColor: "red", confirmButtonText: "Delete", })
        console.log("Result ::: ", result);

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + delete_ecommerce_product}`, payload);
            console.log("Delete Ecommerce Product Saga Response ::: ", data);
            if (data?.status) {
                Swal.fire({ icon: "success", title: "Ecommerce Product Deleted Successfully", showConfirmButton: false, timer: 2000, });
                yield put({ type: actionTypes.GET_ECOMMERCE_PRODUCT, payload: null });
            }
        }
    } catch (error) {
        Swal.fire({ icon: "error", text: "Failed To Delete Ecommerce Product", showConfirmButton: false, timer: 2000, });
        console.log("Delete Ecommerce Product Saga Error ::: ", error?.response?.data);
    }
}

function* changeEcommerceProductStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({ title: `Are You Sure To Change Status`, icon: "warning", showCancelButton: true, confirmButtonColor: "#2A9BAA", cancelButtonColor: "red", confirmButtonText: "Yes", cancelButtonText: "No" })

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + change_ecommerce_product_status}`, payload);
            console.log("Change Status Ecommerce Product Saga Response ::: ", data)

            if (data?.status) {
                Swal.fire({ icon: "success", title: "Status Change Successfully", showConfirmButton: false, timer: 2000, });
                yield put({ type: actionTypes.GET_ECOMMERCE_PRODUCT, payload: null })
            }
        }
    } catch (error) {
        Swal.fire({ icon: "error", text: "Failed To Change Status", showConfirmButton: false, timer: 2000, });
        console.log("Change Status Ecommerce Product Saga Error ::: ", error?.response?.data)
    }
}

export default function* ecommerceSaga() {
    yield takeLeading(actionTypes?.GET_ECOMMERCE_CATEGORY, getEcommerceCategory);
    yield takeLeading(actionTypes?.CREATE_ECOMMERCE_CATEGORY, createEcommerceCategory);
    yield takeLeading(actionTypes?.UPDATE_ECOMMERCE_CATEGORY, updateEcommerceCategory);
    yield takeLeading(actionTypes?.DELETE_ECOMMERCE_CATEGORY, deleteEcommerceCategory);
    yield takeLeading(actionTypes?.CHANGE_ECOMMERCE_CATEGORY_STATUS, changeEcommerceCategoryStatus);
    yield takeLeading(actionTypes?.GET_ECOMMERCE_SUB_CATEGORY, getEcommerceSubCategory);
    yield takeLeading(actionTypes?.CREATE_ECOMMERCE_SUB_CATEGORY, createEcommerceSubCategory);
    yield takeLeading(actionTypes?.UPDATE_ECOMMERCE_SUB_CATEGORY, updateEcommerceSubCategory);
    yield takeLeading(actionTypes?.DELETE_ECOMMERCE_SUB_CATEGORY, deleteEcommerceSubCategory);
    yield takeLeading(actionTypes?.CHANGE_ECOMMERCE_SUB_CATEGORY_STATUS, changeEcommerceSubCategoryStatus);
    yield takeLeading(actionTypes?.GET_ECOMMERCE_SUB_CATEGORY_BY_CATEGORY_ID, getEcommerceSubCategoryByCategoryId);
    yield takeLeading(actionTypes?.GET_ECOMMERCE_ATTRIBUTE, getEcommerceAttribute);
    yield takeLeading(actionTypes?.CREATE_ECOMMERCE_ATTRIBUTE, createEcommerceAttribute);
    yield takeLeading(actionTypes?.UPDATE_ECOMMERCE_ATTRIBUTE, updateEcommerceAttribute);
    yield takeLeading(actionTypes?.DELETE_ECOMMERCE_ATTRIBUTE, deleteEcommerceAttribute);

    yield takeLeading(actionTypes?.GET_ECOMMERCE_PRODUCT, getEcommerceProduct);
    yield takeLeading(actionTypes?.CREATE_ECOMMERCE_PRODUCT, createEcommerceProduct);
    yield takeLeading(actionTypes?.UPDATE_ECOMMERCE_PRODUCT, updateEcommerceProduct);
    yield takeLeading(actionTypes?.DELETE_ECOMMERCE_PRODUCT, deleteEcommerceProduct);
    yield takeLeading(actionTypes?.CHANGE_ECOMMERCE_PRODUCT_STATUS, changeEcommerceProductStatus);
}
